<template>
    <div class="day-cell">
        <div class="date"> {{ day.split('-').slice(1).join('-') }}
            <span class="orange">{{ '[' + getDateTypeName + ']' }}</span>
        </div>
        <span class="tag" v-if="getDutyManageUser">
            {{(getDateType==0?"晚间值班人":"全天值班人")}}：{{ getDutyManageUser }} <i class="el-icon-close" @click="removeManageUser(day)"></i>
        </span>

        <el-dropdown v-if="!getDutyManageUser && isSelected" @command="setManageUser" class="dropdown">
            <span class="el-dropdown-link">
                {{ getDateType == 0 ? '设置晚间值班' : '设置全天值班' }}
                <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="item.UserId" v-for="(item, index) in djrArr" v-bind="item" :key="index">{{
                    item.RealName }}</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script> 
export default {
    props: {
        day: {
            type: String,
            required: true
        },
        djrArr: {
            type: Array,
            required: true
        },
        dayList: {
            type: Array,
            required: true
        },
        dytyList: {
            type: Array,
            required: true
        },
        isSelected: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            // nummm: 0
        }
    },
    computed: {
        getDutyManageUser() {
            //   this.nummm = this.nummm + 1;
            //     console.log("getDutyManageUser num:" + this.nummm);
            console.log("getDutyManageUser date:" + this.day);

            if (this.dytyList && this.day) {
                // console.log("getDutyManageUser date:" + date);

                var data = this.dytyList.find(f => f.Date == this.day);
                // console.log("getDutyManageUser data:" + JSON.stringify(data));
                if (data) {
                    var userName = data.ManageUserName;
                    return userName;
                }
            }
            return "";
        },
        getDateType() {
            // 日期的类别：
            //  1.设置为节假日,且是3倍工资的节假日，比如10.1国庆节，前3天是3倍后面就不是了，则前3天的日期类型为1
            //  2.周末设置为工作日 
            //  3.工作日设置为周末
            //  4.设置为普通节假日，比如10.1国庆节，整个国庆节放假都是普通节假日
            var date = this.day;
            if (this.dayList) {
                var date = this.dayList.find(f => f.Date == date);
                if (date) {
                    var dayType = date.DayType;
                    return dayType;
                }
            }
            return 0;
        },

        getDateTypeName() {
            // 日期的类别：
            //  0.工作日
            //  1.设置为节假日,且是3倍工资的节假日，比如10.1国庆节，前3天是3倍后面就不是了，则前3天的日期类型为1
            //  2.周末设置为工作日 
            //  3.工作日设置为周末
            //  4.设置为普通节假日，比如10.1国庆节，整个国庆节放假都是普通节假日
            //  5.周末
            var date = this.day;

            var dateTypeName = "工作日";
            if (this.dayList) {
                var date = this.dayList.find(f => f.Date == date);
                if (date) {
                    dateTypeName = date.DayTypeName;
                }
            }
            return dateTypeName;
        },
    },

    methods: {

        // 获取对接人
        getTakeOverUserListFun() {
            getTakeOverUserList().then(res => {
                this.djrArr = res.Data;
            })
        },
        setManageUser(userId) {
            this.$emit('setManageUser', userId);
        },
        removeManageUser(userId){
            this.$emit('removeManageUser', userId);
        }
    }
}
</script>

<style scoped lang="scss">
.day-cell {
    position: relative;


    .date {
        width: 100%;
        border: 1p solid red;
    }

    span.orange {
        //    color: #E6A23C;
    }

    span.tag {
        font-size: 12px;
        display: block;
        padding: 10px 3px;
        background: #e6a23c;
        color: white;
        display: flex;
        align-items: center;
        position: relative;
        margin-top: 10px;

        i {
            float: right;
            position: absolute;
            right: 5px;

            // border: 1px solid red;
            padding: 2px 5px;
        }
    }

    .dropdown {
        margin-top: 20px;
    }

}
</style>